import { useEffect, useState } from 'react'
import { isThemeMode, THEME_STORAGE_KEY, type ThemeMode } from '../../domain/theme'

const systemQuery = '(prefers-color-scheme: dark)'

const readStoredMode = (): ThemeMode => {
  const stored = localStorage.getItem(THEME_STORAGE_KEY)
  return isThemeMode(stored) ? stored : 'system'
}

export const useTheme = () => {
  const [mode, setMode] = useState<ThemeMode>(readStoredMode)
  const [systemDark, setSystemDark] = useState(() => matchMedia(systemQuery).matches)
  const resolved = mode === 'system' ? (systemDark ? 'dark' : 'light') : mode

  useEffect(() => {
    const media = matchMedia(systemQuery)
    const update = (event: MediaQueryListEvent) => setSystemDark(event.matches)
    media.addEventListener('change', update)
    return () => media.removeEventListener('change', update)
  }, [])

  useEffect(() => {
    document.documentElement.dataset.theme = resolved
    document.documentElement.style.colorScheme = resolved
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', resolved === 'dark' ? '#0a0b10' : '#f6f7fb')
  }, [resolved])

  const selectMode = (nextMode: ThemeMode) => {
    localStorage.setItem(THEME_STORAGE_KEY, nextMode)
    setMode(nextMode)
  }

  return { mode, selectMode }
}
